import { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { Typography } from 'antd';

import { getMemberRequest, requestMember, search } from 'store/eligibility/actions';
import { getAuthEnabledProviderList } from 'store/authorization/provider/actions';
import { getAllDesc } from 'store/app/ipa/actions';
import { getHelpCenterLinks } from 'store/app/helpCenter/actions';

import MemberRequestForm from 'components/Eligibility/MemberRequestForm';

import MemberRequestPageProps from './Proptypes';

import styles from './MemberRequest.module.scss';
import notifier from 'utils/notifier';
import { ErrorResponse } from 'utils/types';
import HelpCenterLink from 'components/Common/HelpCenterLink';

const { Title } = Typography;


const MemberRequestPage = (props: MemberRequestPageProps) => {

  const [helpCenter, setHelpCenter] = useState<any>([]);

  useEffect(() => {
    getHelpCenterLinks();
  }, []);

  const getHelpCenterLinks = () => {
    props.getHelpCenterLinks(sessionStorage.getItem('ipaGroup')!, '/eligibility/member-request', 'page')
      .then((response: any) => {
        setHelpCenter(response);
    })
    .catch((err: ErrorResponse) => {
      console.log(err?.response?.data?.Message);
    });
  }

  return (
    <div className={styles["member-request-page"]}>
      <div className={styles["header-title"]}>
        <Title level={4} className="ml-3">Member Request</Title>
      </div>
      {
          helpCenter?.length > 0 ? helpCenter.map((hc: any) => {
            return (
              <>
                <div className={`row ${styles['help-center-link']}`}>
                  <div className="col-md-24">
                    <HelpCenterLink
                      clickEventId={hc.ClickEventId}
                      linkName={hc.LinkName}
                      pagePath={hc.PagePath}
                      url={hc.Link}
                      companyId={hc.CompanyId}
                    />
                  </div>
                </div>
              </>
            );
          }) : null
        }
      <MemberRequestForm
        getAuthEnabledProviderList={props.getAuthEnabledProviderList}
        getAllDesc={props.getAllDesc}
        requestMember={props.requestMember}
        getMemberRequest={props.getMemberRequest}
        search={props.search}
        isFetchingMember={props.isFetchingMember}
        isRequestingMember={props.isRequestingMember}
      />

    </div>
  )
}

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingMember: store.rootReducer.eligibility.isFetchingMember,
  isRequestingMember: store.rootReducer.eligibility.isRequestingMember,
});


const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getMemberRequest,
    requestMember,
    getAuthEnabledProviderList,
    getAllDesc,
    getHelpCenterLinks,
    search
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(MemberRequestPage);